function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import pick from 'lodash/pick';
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import BaseCarousel from './_internal/BaseCarousel';
import FullCarousel from './_internal/FullCarousel';
import { BASE_CAROUSEL_PROPS, FULL_CAROUSEL_PROPS, CAROUSEL_PROP_TYPES, TYPE_ICON } from './constants';

var Carousel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Carousel, _PureComponent);

  function Carousel() {
    _classCallCheck(this, Carousel);

    return _possibleConstructorReturn(this, _getPrototypeOf(Carousel).apply(this, arguments));
  }

  _createClass(Carousel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          alwaysShowSideNavigation = _this$props.alwaysShowSideNavigation,
          alwaysShowBottomNavigation = _this$props.alwaysShowBottomNavigation,
          autoTransition = _this$props.autoTransition,
          hasTopControls = _this$props.hasTopControls,
          usesNewStyle = _this$props.usesNewStyle,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          props = _objectWithoutProperties(_this$props, ["children", "alwaysShowSideNavigation", "alwaysShowBottomNavigation", "autoTransition", "hasTopControls", "usesNewStyle", "title", "subtitle"]);

      var carouselClassNames = classNames('eds-carousel', {
        'eds-carousel--has-top-controls': hasTopControls,
        'eds-carousel--new-style': usesNewStyle
      });

      if (hasTopControls) {
        return React.createElement("section", {
          className: carouselClassNames
        }, React.createElement(FullCarousel, _extends({}, pick(props, FULL_CAROUSEL_PROPS), {
          initialShowSideNavigation: alwaysShowSideNavigation,
          initialAutoTransition: autoTransition,
          showBottomNavigation: alwaysShowBottomNavigation,
          usesNewStyle: usesNewStyle,
          title: title,
          subtitle: subtitle
        }), children));
      }

      return React.createElement("section", {
        className: carouselClassNames
      }, React.createElement("div", {
        className: "eds-show-up-sw"
      }, React.createElement(FullCarousel, _extends({}, pick(props, FULL_CAROUSEL_PROPS), {
        initialShowSideNavigation: alwaysShowSideNavigation,
        initialAutoTransition: autoTransition,
        showBottomNavigation: alwaysShowBottomNavigation,
        usesNewStyle: usesNewStyle,
        title: title,
        subtitle: subtitle
      }), children)), React.createElement("div", {
        className: "eds-show-down-sm eds-align--center"
      }, React.createElement(BaseCarousel, _extends({}, pick(props, BASE_CAROUSEL_PROPS), {
        customNavigation: undefined,
        itemsPerSlide: 1,
        showNavigation: true
      }), children)));
    }
  }]);

  return Carousel;
}(PureComponent);

_defineProperty(Carousel, "propTypes", CAROUSEL_PROP_TYPES);

_defineProperty(Carousel, "defaultProps", {
  initialDisplayIndex: 0,
  itemsPerSlide: 1,
  fullWidth: false,
  alwaysShowSideNavigation: false,
  alwaysShowBottomNavigation: false,
  bottomNavigationType: TYPE_ICON,
  fixAspectRatio: false,
  isNotContinuous: false,
  hasTopControls: false,
  usesNewStyle: false
});

export { Carousel as default };